var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 36810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_3815_65848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2 15.9403L19.44 7.69899L16.7222 10.2206C16.7222 11.3686 15.9578 12.2911 15.0066 12.2911C14.0554 12.2911 13.291 11.3686 13.291 10.2411L13.9704 9.42105L12 7.04297L10.0296 9.42105L10.7091 10.2411C10.7091 11.3686 9.9447 12.2911 8.99347 12.2911C8.04224 12.2911 7.27786 11.3686 7.27786 10.2206L4.56006 7.71949L5.80006 15.9608H18.2V15.9403ZM5.7491 16.9243H18.3189V16.4323H5.7491V16.9243Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3815_65848",
    x1: 0.96,
    y1: 17.16,
    x2: 23.64,
    y2: 7.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D39E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490622,
    stopColor: "#FFF0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755955,
    stopColor: "#D39E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD9F00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.ccf24e1c3ce15572aa88aad8d8eca733.svg";
export { ForwardRef as ReactComponent };